// @flow

import React from 'react'
import { useSelector } from 'react-redux'

import ReactHtmlParser from 'react-html-parser'

import { AppWrapper } from '../../containers'
import { HELPER, IMAGE_SRC, APP_HELPER, ERROR_MSGS } from '../../utils'

const showErrorTitle = (message) => {
	const title = APP_HELPER.CHECK_LTR_LANG() ? ERROR_MSGS.EN.BAD_REQUEST : ERROR_MSGS.UR.BAD_REQUEST
	return !HELPER.isEmpty(message) ? message : title
}

const showErrorDescription = (description) => {
	return !HELPER.isEmpty(description) ? '- ' + description : ''
}

function Error() {
	const { browseStores, catalog_access_rejected } = useSelector((state) => state.config)
	const { message, status, description } = useSelector((state) => state.error)

	const redirectToRoot = () => {
		if (catalog_access_rejected && browseStores) {
			APP_HELPER.MOVE_TO_VIEW_ALL_STORES()
		} else {
			HELPER.REDIRECT_TO_PATH(process.env.REACT_APP_BSECURE_WEBSITE_URL)
		}
	}

	return (
		<>
			<AppWrapper
				showBackIcon={browseStores}
				observeBackHistory={true}
				showLangIcon={false}
				showCartIcon={false}
				showAccountDropdown={false}
				showFooter={false}
			>
				<section className="errorPage">
					<div className="errorPageLogo">
						<img src={IMAGE_SRC.BSECURE_FAVICON} alt="website logo" />
					</div>
					<div className="errorPageText">
						<h1>
							{APP_HELPER.CHECK_LTR_LANG()
								? ERROR_MSGS.EN.ERROR_SUBTITLE
								: ERROR_MSGS.UR.ERROR_SUBTITLE}
						</h1>
						<p dir={APP_HELPER.GET_LANG_DIRECTION()}>
							{status}
							{showErrorDescription(description)}
						</p>
						<div className="error-title" dir={APP_HELPER.GET_LANG_DIRECTION()}>
							{ReactHtmlParser(showErrorTitle(message))}
						</div>
						<span
							onClick={redirectToRoot}
							className="btn btn-error-back"
							dir={APP_HELPER.GET_LANG_DIRECTION()}
						>
							{APP_HELPER.CHECK_LTR_LANG()
								? ERROR_MSGS.EN.BACK_BTN_TEXT
								: ERROR_MSGS.UR.BACK_BTN_TEXT}
						</span>
					</div>
				</section>
			</AppWrapper>
		</>
	)
}

export default Error
